/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { injectIntl } from 'react-intl';
import styles from './styles.scss';


const kEnHelps = {
  RXParamSetupReq: 'Sets the reception slots parameters.',
  TXParamSetupReq: 'Used by the network server to set the maximum allowed dwell time and Max EIRP of end-device, based on local regulations',
  DevStatusReq: 'Requests the status of the end-device.',
  NewChannelReq: 'Creates or modifies the definition of a radio channel.',
  RXTimingSetupReq: 'Sets the timing of the of the reception slots',
  LinkADRReq: 'Requests the end-device to change data rate, transmit power, repetition rate or channel.',
  DutyCycleReq: 'Sets the maximum aggregated transmit duty-cycle of a device.',
  DLChannelReq: 'Modifies the definition of a downlink RX1 radio channel by shifting the downlink frequency from the uplink frequencies (i.e. creating an asymmetric channel)',
  UpdChPlanReq: 'Send channel plan to the device(AISenz Inc. exclusive command, required AISenz module supported)',
  AddBroadcastReq: 'Add Broadcast(AISenz Inc. exclusive command, required AISenz module supported)',
  RemoveBroadcastReq: 'Remove Broadcast(AISenz Inc. exclusive command, required AISenz module supported)',
  UpdChPlanReqV2: 'Applies to 3.0.0 and later versions',
  AddBroadcastReqV2: 'Applies to 3.0.0 and later versions',
  RemoveBroadcastReqV2: 'Applies to 3.0.0 and later versions',
};

const kZhHelps = {
  RXParamSetupReq: '设置接收窗口参数。',
  TXParamSetupReq: '用于 network server 设置终端设备的最大允许驻留时间和最大EIRP, 基于当地的管制',
  DevStatusReq: '请求终端设备的状态。',
  NewChannelReq: '创建或修改无线信道的定义。',
  RXTimingSetupReq: '设置接收窗口的时机。',
  LinkADRReq: '请求终端设备修改速率、传输功率、重发速率或信道。',
  DutyCycleReq: '设置设备的最大聚合发射占空比。',
  DLChannelReq: '通过从上行链路频点平移到下行链路频点（譬如创建一个非对称信道）来修改一个下行RX1无线信道的定义',
  UpdChPlanReq: '向设备发送信道计划（艾森智能专属命令，需艾森模组支持）',
  AddBroadcastReq: '添加广播（艾森智能专属命令，需艾森模组支持）',
  RemoveBroadcastReq: '删除广播（艾森智能专属命令，需艾森模组支持）',
  UpdChPlanReqV2: '适用于3.0.0以后的版本',
  AddBroadcastReqV2: '适用于3.0.0以后的版本',
  RemoveBroadcastReqV2: '适用于3.0.0以后的版本',
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  command: React.PropTypes.string.isRequired,
};

class MacHelp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      command: props.command,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { command } = nextProps;
    if (command !== this.props.command) {
      this.setState({ command });
    }
  }

  render() {
    const { intl: { locale } } = this.props;
    const { command } = this.state;
    let helpDict = kEnHelps;
    if (locale === 'zh') {
      helpDict = kZhHelps;
    }

    return (
      <div className={styles.help}>
        <ReactCSSTransitionGroup
          transitionName={{
            appear: styles.appear,
            appearActive: styles.appearActive,
            enter: styles.enter,
            enterActive: styles.enterActive,
          }}
          transitionAppear
          transitionAppearTimeout={1000}
          transitionEnterTimeout={1000}
          transitionLeave={false}
        >
          <span key={command}>
            <i className="fa fa-info-circle" />{' '}
            {helpDict[command]}
          </span>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

MacHelp.propTypes = propTypes;

export default injectIntl(MacHelp);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/MacHelp/index.jsx